import React, {Component} from 'react';
import {Modal} from 'antd';
import './rechargeDetail.less';

function GetStatus(props) {
  const {type, status} = props;
  if (type === 'status') {
    let text = '';
    let statusClass = 'status status--pending';
    switch (status) {
      case '1':
        text = '待审核';
        statusClass = 'status status--pending';
        break;
      case '2':
        text = '审核通过';
        statusClass = 'status status--success';
        break;
      case '3':
        text = '审核不通过';
        statusClass = 'status status--danger';
        break;
      default:
        text = '';
        statusClass = 'status';
    }
    return <span className={statusClass}>{text}</span>;
  }

  if (type === 'invoiceType') {
    switch (status) {
      case '1':
        return <span>增值税普票-纸制</span>;
      case '2':
        return <span>增值税普票-电子</span>;
      case '3':
        return <span>增值税专票</span>;
      default:
        return <span />;
    }
  }
  return <span />;
}

// 充值详情
class RechargeDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {}, // 充值详情
      isShowImg: false, // 显示图片原图
      picUrl: '', // 图片链接地址
    };
  }

  componentWillMount() {
    this.setState({detail: this.props.detail});
  }

  componentWillReceiveProps(props) {
    this.setState({detail: props.detail});
  }

  // 显示图片
  showImg = (value, url) => {
    this.setState({isShowImg: value, picUrl: url});
  }

  render() {
    const {detail, isShowImg, picUrl} = this.state;
    const recharge = detail.recharge || {};
    const rechargeInvoice = detail.recharge_invoice || {};
    const files = detail.files || [];
    return (
      <div id="rechargeDetail">
        <Modal
          title={false}
          footer={false}
          onCancel={this.showImg.bind(this, false, '')}
          visible={isShowImg}
          width="880px"
        >
          <img src={picUrl} alt="" width="100%" />
        </Modal>
        <ul className="detail">
          <li>
            <p>创建日期：</p>
            <span>{recharge.gmt_created}</span>
          </li>
          <li>
            <p>代理商ID/名称：</p>
            <span>{recharge.agent_no}/{recharge.agent_name}</span>
          </li>
          <li>
            <p>充值单号：</p>
            <span>{recharge.recharge_no}</span>
          </li>
          <li>
            <p>充值金额：</p>
            <span>{recharge.recharge_amt}</span>
          </li>
          <li>
            <p>充值方式：</p>
            <span>{recharge.recharge_type === '1' ? '返佣账户充值' : '线下转账'}</span>
          </li>
          <li>
            <p>是否开票：</p>
            <span>{recharge.invoice_type === '0' ? '否' : '是'}</span>
          </li>
          {
            recharge.invoice_type !== '0' ? <li>
              <p>发票类型：</p>
              <GetStatus status={recharge.invoice_type} type="invoiceType" />
            </li> : null
          }
          {
            recharge.invoice_type !== '0' ? <li>
              <p>发票信息：</p>
              <ul className="info">
                <li>
                  <p>名称:</p>
                  <span>{rechargeInvoice.invoice_name}</span>
                </li>
                {
                  recharge.invoice_type === '2' ? <li>
                    <p>邮箱:</p>
                    <span>{rechargeInvoice.email_address}</span>
                  </li> : null
                }
                <li>
                  <p>税号:</p>
                  <span>{rechargeInvoice.invoice_tax_no}</span>
                </li>
              </ul>
            </li> : null
          }
          {
            recharge.recharge_type !== '1' ? <li className="detail__images">
              <p>打款截图：</p>
              {
                files.map((item, index) => (
                  <div className="imgBox" key={index} >
                    <div onClick={this.showImg.bind(this, true, item)}>查看</div>
                    <img src={item} alt="" />
                  </div>
                ))
              }
            </li> : null
          }
        </ul>
        <h3>审核信息</h3>
        <ul className="audit">
          <li>
            <p>初审状态：</p>
            <GetStatus status={recharge.first_check_status} type="status" />
          </li>
          <li>
            <p>审核时间：</p>
            <span>{recharge.gmt_first_check}</span>
          </li>
          <li>
            <p>审核人：</p>
            <span>{recharge.first_check_name}</span>
          </li>
          <li>
            <p>审核意见：</p>
            <span>{recharge.first_check_rmk}</span>
          </li>
        </ul>
        <ul className="audit">
          <li>
            <p>复审状态：</p>
            <GetStatus status={recharge.second_check_status} type="status" />
          </li>
          <li>
            <p>审核时间：</p>
            <span>{recharge.first_check_status === '3' ? recharge.gmt_first_check : recharge.gmt_second_check}</span>
          </li>
          <li>
            <p>审核人：</p>
            <span>{recharge.first_check_status === '3' ? recharge.first_check_name : recharge.second_check_name}</span>
          </li>
          <li>
            <p>审核意见：</p>
            <span>{recharge.first_check_status === '3' ? recharge.first_check_rmk : recharge.second_check_rmk}</span>
          </li>
        </ul>
      </div>
    );
  }
}
export default RechargeDetail;



// WEBPACK FOOTER //
// ./src/components/frontEnd/rechargeDetail/rechargeDetail.jsx